<div class="container-fluid">
  <div class="row">
    <!-- Sidebar -->
    <div class="col-2 bg-light vh-100 p-3 d-flex flex-column">
      <h5 class="mb-3">Creator</h5>
      <ul class="nav flex-column flex-grow-1">
        <li class="nav-item">
          <a
            class="nav-link"
            href="#"
            [class.active]="isActive('/creator/project-list')"
            (click)="navigateTo('/creator/project-list', $event)"
            >Edit slides for project</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="#"
            [class.active]="isActive('/creator/project-from-lesson')"
            (click)="navigateTo('/creator/project-from-lesson', $event)"
            >New project from lesson</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="#"
            [class.active]="isActive('/creator/audio-gen')"
            (click)="navigateTo('/creator/audio-gen', $event)"
            >Excel audio generation</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="#"
            [class.active]="isActive('/creator/lesson-excel-import')"
            (click)="navigateTo('/creator/lesson-excel-import', $event)"
            >Excel lesson import</a
          >
        </li>
      </ul>
      <div class="border-top pt-3 mt-2 d-grid gap-2">
        <button type="button" class="btn btn-outline-secondary btn-sm text-start" (click)="goBack()">
          ← Back
        </button>
        <button type="button" class="btn btn-outline-danger btn-sm text-start" (click)="requestLogout()">
          Logout
        </button>
      </div>
    </div>

    <!-- Main content -->
    <div class="col-10 p-4">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
